import {Component, EventEmitter, Inject, Input, NgZone, OnInit, Output} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AddOpportunityService } from "@app/features/customers/add-opportunity/service/add-opportunity.service";
import {PropertyViewService} from "@app/features/customers/customer/property-view/service/property-view.service";
import {ReplaySubject, Subscription} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {AuthService} from "@app/core";
import {CommonService} from "@app/services";

declare var $: any;
declare var tinymce: any;

@Component({
    selector: 'app-call-log-modal',
    templateUrl: './call-log-modal.component.html',
    styleUrls: ['../communication-modal.scss']
})
export class CallLogModalComponent implements OnInit {
    callForm: FormGroup;
    customerCallDetails: object;
    callType = [{ id: 'Incoming Call', value: 'Inbound call' }, { id: 'Outgoing Call', value: 'Outbound call' }];
    @Input() scheduled: boolean = true;
    editId: any;
    callActivityShow: boolean = false;
    activityIsScheduled: Array<any> = [];
    completed: boolean = true;
    scheduledData: any;
    saveDisabled: boolean = false;
    isContactNotFound: boolean = false;
    todayActivityId:any;
    tinyMCEIntervel: any;
    editor: any;
    @Input() customerId: number;
    @Input() opportunityId: number;
    @Input() showCallLogModal: boolean = false;
    @Input() editCallData: any;
    @Input() activityList: any;
    @Output() onSave: EventEmitter<any> = new EventEmitter();
    @Output() onClose: EventEmitter<any> = new EventEmitter();
    @Input() isCommonRoute: boolean = false;
    @Input() customerType: string;
    @Input() tablePKId: number;
    @Input() screenType: string;
    @Input() usersList: any;
    customTagsList: any[] = [];
    customTagForm: FormGroup;
    selectedUsersList: any = [];
    users: any = [];
    isAssigned: boolean = false;
    private subscriptions = new Subscription();
    private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
    previouslySelectedUsers: any = [];
    usersWritePermission:boolean;
    usersUpdatePermission:boolean;

    constructor(private fb: FormBuilder,
        private opportunityService: AddOpportunityService,
                private zone: NgZone,
        @Inject('confirmationBoxHelper') private confirmationBoxHelper,
                @Inject('$scope') private ajsScope,
                private propertyviewservice: PropertyViewService,
                private authService: AuthService,
                private commonService: CommonService,) {
    }

    ngOnInit() {
        this.usersWritePermission = this.authService.permitted(['SetupJobUsers.writeaccess']) === true;
        this.usersUpdatePermission = this.authService.permitted(['SetupJobUsers.updateaccess']) === true;
        if (this.usersList && this.usersList.length) {
            this.setUserList(this.usersList);
        }
        const users = this.propertyviewservice.timelineDetails$.pipe(takeUntil(this.destroyed$)).subscribe((data: any) => {
            if (data && data.hasOwnProperty('assignee')) {
                let assignee = data.assignee ? data.assignee : [];
                this.setUserList(assignee);
            }else if(!this.usersList || this.usersList.length === 0){
                this.commonService.getUsersList().subscribe((res)=>{
                    this.setUserList(res.userRecords);
                })
            }
        });

        this.subscriptions.add(users);
    }

    ngOnChanges(changes) {
        if (changes.usersList && changes.usersList.currentValue && changes.usersList.currentValue.length) {
            this.setUserList(changes.usersList.currentValue);
        }
        if (changes.showCallLogModal) {
            if (this.showCallLogModal) {
                if (this.editCallData == null) {
                    let showContent = 'call';

                    if (this.activityList) {
                        /* for (var filter = 0; filter < this.activityList.length; filter++) {
                             // for (var record = 0; record < this.activityList[filter]['records'].length; record++) {
                                 if (this.activityList[filter]['isScheduled'] == 'true' && this.activityList[filter]['activityStatus'] != 'Completed'
                                     && this.activityList[filter]['activityType'].toLowerCase() == showContent.toLowerCase())
                                     this.activityIsScheduled.push(this.activityList[filter])
                             // }
                         }*/
                        if (this.activityList.length != 0 && this.activityList[0].length != 0) {
                            this.callActivityShow = true
                            this.completed = true
                        } else {
                            this.callActivityShow = false
                            this.completed = false
                        }
                    }
                    this.buildForm();
                    if(!this.isCommonRoute){
                        setTimeout(() => {
                            this.todayActivity()
                        }, 500);
                    }
                    $(".modal-header").css("background", "#5E7F7D");
                    $('.callLogModal').modal('show');
                    $(".modal-dialog").addClass("modal-dialog-open");
                    setTimeout(() => {
                        // this.updateTinyMCEValues();
                    }, 100);
                }
                else {
                    if (this.editCallData['activityType'] == 'Call') {
                        this.editId = this.editCallData.communications.phoneId
                        this.callActivityShow = false;
                        this.buildForm()
                        this.callForm.patchValue({
                            "contactTelephoneId": this.editCallData.communications.contactNumberId,
                            "note": this.editCallData.communications.phoneCallNote,
                            "callType": this.editCallData.communications.calltype
                        })
                        $(".modal-header").css("background", "#5E6D7F")
                        $('#modalPopUp').modal('show');
                        // $(".modal-dialog").css("height", "450px");
                        $(".modal-dialog").addClass("modal-dialog-open")
                        $('.callLogModal').addClass('in')
                        setTimeout(() => {
                            // this.updateTinyMCEValues();
                        }, 100);
                    }
                }
            }
        }
        if (changes.customerId && this.customerId) {
            this.getCustomerCall();
        }
    }

    getCustomerCall() {
        if (this.isCommonRoute) {
            this.opportunityService.getTimelineContacts(this.customerId,this.customerType,this.tablePKId,this.screenType).subscribe(
                (data: any) => {
                    if (Object.values(data).length) {
                        this.customerCallDetails = Object.values(data);
                    } else {
                        this.isContactNotFound = true;
                    }
                })
        }
        else {
            this.opportunityService.getCustomerContact(this.customerId).subscribe(
                data => {
                    if (Object.values(data).length) {
                        this.customerCallDetails = data;
                    } else {
                        this.isContactNotFound = true;
                    }
                })
        }
    }

    buildForm() {
        this.callForm = this.fb.group({
            "contactTelephoneId": ["", Validators.required],
            "activityType": ["Call"],
            "note": [""],
            "customerId": [""],
            "callType": ["Outgoing Call", Validators.required]
        });
    }
    closeModal(emitEvent = true) {
        this.confirmationBoxHelper.getConfirmation('Are you sure you want to discard the log call?', this.ajsScope)
		.then(() => {
            this.closeModalWithoutConfirmation(emitEvent);
		}).catch(() => { });
    }

    closeModalWithoutConfirmation(emitEvent = true) {
        this.editId = null
        this.callForm.controls['activityType'].setValue('')
        this.callForm.controls['customerId'].setValue('')
        this.callForm.controls['note'].setValue('');
        this.editCallData = undefined;
        this.scheduledData = undefined;
        this.scheduled = false;
        this.activityIsScheduled = [];
        $('.callLogModal').modal('hide');
        $("#call-log-modal-dialogue").removeClass("modal-dialog-open");
        if (emitEvent)
            this.onClose.emit(false);
    }

    isScheduledActivity(event) {
        this.scheduled = event.target.checked
    }

    completeActivity(event) {
        this.completed = event.target.checked
    }

    todayActivity() {
        this.opportunityService.getScheduledEmail(this.opportunityId,'Call').subscribe(resp => {
            if (resp) {
                if (resp == false) {
                    this.callActivityShow = false;
                    this.completed = false;
                }
                else {
                    this.callActivityShow = true;
                    this.completed = true;
                    this.todayActivityId = resp;
                }
            }
        })
    }

    saveCall() {
        if (this.isCommonRoute) {
            let callData = this.callForm.value;
            callData.editId = this.editId;
            if (this.selectedUsersList && this.selectedUsersList.length) {
                callData.selectedUsersList = this.selectedUsersList.map(x => x.id);
                callData.isAssigned = this.isAssigned;
            }else {
                callData.selectedUsersList = [];
            }
            callData.isScheduled = this.scheduled;
            if (this.completed) {
                callData.activityIds = this.activityList[0];
            }
            if(this.editCallData){
                callData.communicationId = this.editCallData.communications.communicationId;
            }
            this.onSave.emit(callData);
        }
        else {
            this.saveDisabled = true
            this.callForm.get('customerId').setValue(this.customerId);
            let callData = this.callForm.value;
            if (this.completed) {
                callData = this.callForm.value
                let activityId = this.todayActivityId;
                /*if (this.activityIsScheduled.length != 0) {
                    for (var i = 0; i < this.activityIsScheduled.length; i++) {
                        activityId.push(this.activityIsScheduled[i]['activity_id'])
                    }
                } else {
                    if (this.scheduledData) {
                        if (this.scheduledData.hasOwnProperty('activity_id')) {
                            activityId.push(this.scheduledData.activity_id)
                        } else {
                            activityId.push(this.scheduledData.activityId)
                        }
                    }
                }*/
                callData.activityIds = activityId
            }
            // this.editId = event.editId;
            // callData.activityIds = this.activityEmail;
            let url;
            if (this.editId) {
                url = `sales/edit_opportunity_call/${this.editId}`
            } else {
                url = `sales/opportunityActivityCall/${this.opportunityId}`
            }
            this.opportunityService.createOpportunityCall(callData, url).subscribe(
                data => {
                    // If this schedule, open the schedule activity modal
                    this.onSave.emit(this.scheduled);
                    this.closeModalWithoutConfirmation();
                    this.saveDisabled = false;
                    if (this.scheduledData) {
                        if (this.scheduledData.hasOwnProperty('activityId')) {
                            this.opportunityService.refreshCompleteActivity('complete')
                        }
                    }
                });
        }
    }

    // onChange = (_: any) => {
    //     const message = tinymce.get('email-template-message').getContent()
    //     this.callForm.patchValue({
    //         note: message
    //     });
    //     this.callForm.updateValueAndValidity();
    // };
    setUserList(assignee){
        if (assignee) {
            this.usersList = assignee.map(x => {
                const displayName =
                    (x.username && String(x.username).trim());
                return {
                    ...x,
                    value: displayName,
                }
            }).filter((x: any) => x && x.id != null && x.value !== '');
            if (this.editCallData) {
                let content = {
                    html: this.editCallData.communications.phoneCallNote
                }
                this.onContentChange(content, true);
            }
        }
    }

    onContentChange(event, getSelectedUsers = false) {
        if (event.text === '\n') {
            this.saveDisabled = true;
        } else {
            this.saveDisabled = false;
        }
        this.onChange();
        const contentEl = $(event.html).find('[data-denotation-char=""]');
        let userList = [];
        if (contentEl.length) {
            for (let i = 0; i < contentEl.length; i++) {
                let index = userList.findIndex((data: any) => data.id == contentEl[i].dataset['id']);
                if (index < 0) {
                    let user = this.usersList.find((data: any) => data.id == contentEl[i].dataset['id']);
                    userList.push(user);
                }
            }
        }

        this.selectedUsersList = [];
        if (userList.length && !getSelectedUsers) {

            // Removing the user from the selected list
            this.previouslySelectedUsers.forEach((user, index) => {
                let checkPreviousIndex = userList.findIndex((data: any) => data == user);
                if (checkPreviousIndex === -1) {
                    this.previouslySelectedUsers.splice(index, 1);
                }
            })

            // Checking if the user is already selected
            userList.forEach((user) => {
                let checkPreviousIndex = this.previouslySelectedUsers.findIndex((data: any) => data == user);
                if (checkPreviousIndex < 0) {
                    this.selectedUsersList.push(user);
                }
            })

        } else {
            this.previouslySelectedUsers = userList;
        }
    }

    onChange = () => {
        const message = this.callForm.value.note;
        this.customTagsList.forEach((ct) => {
            if (!message.includes(`>{${ct.name}}</`) && !this.customTagForm.controls[ct.name].value) {
                this.customTagForm.controls[ct.name].setValidators(Validators.nullValidator);
                this.customTagForm.controls[ct.name].disable();
            }
        })
    };

    ngOnDestroy() {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
